export const ControllerListSuccess = 'CONTROLLER_LIST_SUCCESS';
export const ControllerAllListSuccess = 'CONTROLLER_ALL_LIST_SUCCESS';
export const ControllerDetailsSuccess = 'CONTROLLER_DETAILS_SUCCESS';
export const ControllerFiltersSuccess = 'CONTROLLER_FILTERS_SUCCESS';

export function setControllerListAction(data) {
  return {
    type: ControllerListSuccess,
    payload: data,
  };
}

export function setAllControllerListAction(data) {
  return {
    type: ControllerAllListSuccess,
    payload: data,
  };
}

export function setGetControllerDetails(data) {
  return {
    type: ControllerDetailsSuccess,
    payload: data,
  };
}

export function setGetControllerFilters(data) {
  return {
    type: ControllerFiltersSuccess,
    payload: data,
  };
}
